var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupons"},[(_vm.selectedCoupons.length)?_c('div',[_c('h3',{staticClass:"block-title my-4"},[_vm._v(_vm._s(_vm.$t('coupon.all')))]),_c('BsiCouponList',{attrs:{"items":_vm.selectedCoupons}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }